import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import moment from 'moment'
import i18n from './i18n';
import { initPush, registerForPush, getStoredApnsToken } from './push';
import { displayName, fullName, firstName, lastName } from './utils/userName';
import { notifyError } from './store';

Vue.config.productionTip = false

// Globální helper pro jednotné zobrazení jména uživatele (jméno+příjmení → přezdívka)
Vue.mixin({ methods: { displayName, fullName, firstName, lastName } });

moment.locale('cs')

// Last line of defence: an unexpected error must never leave the user staring at a UI that silently does nothing.
const UNEXPECTED_ERROR = "Něco se nepovedlo. Zkuste to prosím znovu, případně aplikaci restartujte.";

Vue.config.errorHandler = (err, vm, info) => {
  console.error("Vue error (" + info + "):", err);
  notifyError(UNEXPECTED_ERROR);
};

// Rejections from component handlers already reach Vue's errorHandler; others (maps, plugins) are only logged.
window.addEventListener('unhandledrejection', (event) => {
  console.error("Unhandled promise rejection:", event.reason);
});

// Initialize push notifications (iOS only)
initPush(store);

// Ensure push token registration after login
store.subscribe((mutation, state) => {
  if (mutation.type === 'setToken' && state.token) {
    const cached = getStoredApnsToken();
    if (cached) {
      // Register any previously stored APNs token immediately
      store.dispatch('registerPushToken', cached);
    }
    // Also attempt a fresh registration to obtain a (new) token if needed
    registerForPush(store);
  }
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
